<template>
    <div>
        <div class="message-header">
            <slot name="icon"></slot>
            <span class="message-header--text"> {{ this.messageHeader }} </span>
        </div>
        <span class = "time">{{ this.timeElapsed }}</span>
        <p class = "userName"><span class="text-light">From:</span> {{ this.userName }}</p>
        <p class="message">{{ this.message }}</p>
    </div>
</template>

<script>
    import moment from 'moment';
    
    export default {
        name: "Message",
        props: ['time','message','userName','messageHeader'],
        data: function () {
            return {
                timeElapsed: this.time
            }
        },
        created: function(){
           this.timer();
        },
        methods:{
            timer() {
                setTimeout(() => {                        
                    this.timeElapsed = moment(this.time, 'hh-mm-ss').fromNow()
                    this.timer()
                }, 1000)
            }
        }
    }
</script>

<style scoped>
    .message-header{
        color: #E7E6FA;
        font-size: 15px;
        font-weight: 600;
        font-size: 18px;
        line-height: 23px;
        margin-bottom: 5px;
        display: flex;
    }

    .message-header--text {
        padding: 0 13px;
    }

    .time{
        right:60px;
        position: absolute;
        margin-top:-27px;
        color: #50C6DF;
        font-size: 12px;
        line-height: 15px;
    }
    .userName{
        margin-top: 4px;
        margin-bottom: 4px;
        font-size: 15px;
        color: #E7E6FA;
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        text-transform: capitalize;
    }

    span.text-light {
        font-size: 14px;
        line-height: 18px;
        color: #FFFFFF;
        opacity: 0.7;
    }

    .userName, .message {
        padding-left: 38px;
    }

    .message{
        color: #E7E6FA;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        color: #E7E6FA;
        word-break: break-all;
    }
</style>


